<div
    class="border-neutral-variant-40/40 card-shadow mb-8 flex max-h-237 min-h-237 max-w-90 min-w-90 flex-col justify-start rounded-lg border bg-white p-8 lg:mt-0 lg:max-w-118 lg:min-w-118"
    [class.mt-0]="isFirst()"
    [class.mt-8]="!isFirst()"
>
    <div class="mb-8 flex flex-col gap-2">
        <packbo-package-badge class="self-start" [package]="package()" />

        @let price = package()?.price;
        @if (price && price > 0) {
            <div>
                <span class="text-display-medium">{{ price | currency: "" : "" : "1.0-2" }}$</span>
                /
                <span class="text-title-medium">{{ "supplier.package.yearly" | transloco }}</span>
            </div>
        } @else {
            <span class="text-display-medium">{{ "supplier.package.free" | transloco }}</span>
        }
    </div>

    <div class="mb-8 flex flex-col gap-6">
        @for (feature of packageFeatures(); track feature.id) {
            <div class="flex items-center gap-3">
                @if (feature.is_included) {
                    <svg-icon
                        class="text-primary"
                        [svgStyle]="{ width: '24px', height: '24px' }"
                        src="assets/icons/Check.svg"
                    />
                } @else {
                    <svg-icon
                        class="text-error-40"
                        [svgStyle]="{ width: '16px', height: '16px' }"
                        src="assets/icons/Close.svg"
                    />
                }
                <span class="text-body-small">{{ feature.translations_refs | getTranslation: "title" }}</span>
            </div>
        }
    </div>

    @let href = (link()?.page_ref | pathFromItem: "page") ? (link()?.page_ref | pathFromItem: "page") : link()?.url;
    @if (href) {
        <a
            [href]="href"
            [target]="link()?.url ? '_blank' : '_self'"
            class="text-body-small bg-primary hover:bg-primary/80 rounded-md px-4 py-3.5 text-center text-white"
        >
            {{ "supplier.package.subscribe" | transloco }}
            {{ package()?.translations_refs | getTranslation: "title" | lowercase }}
        </a>
    }
</div>
